import moment from 'moment';
import { PatientPrimaryInfoProps, ROLE } from '../interface/interface';
import InfoField from './InfoField';
import { useNavigate } from 'react-router-dom';
import { transformPhoneNumber } from '../utils/transformPhoneNumber.ts';
import { useAuth } from 'react-oidc-context';
import { WrapEmail } from './WrapEmail.tsx';
import { WrapAddress } from './WrapAddress.tsx';

const PatientPrimaryInfo = (props: PatientPrimaryInfoProps) => {
  const { user } = useAuth();
  const navigateTo = useNavigate();
  const unformattedPhoneNumber = props.patient?.phone?.mobile;
  const formattedPhoneNumber = unformattedPhoneNumber
    ? transformPhoneNumber(unformattedPhoneNumber)
    : '-';
  return (
    <>
      {props.patient ? (
        <div className="bg-secondary-pink-50 px-5 md:px-10 pt-4 pb-11 rounded-md shadow-sm">
          <div className="flex flex-col md:flex-row md:justify-between md:items-center">
            <h3 className="text-xl md:text-2xl text-primary-blue-500 font-semibold mb-2 md:mb-0">
              Patient Information
            </h3>
            {!props?.patient?.isGuest &&
            !(user?.profile.groups as Array<string>)?.includes(
              ROLE.Patients,
            ) ? (
              <button
                className="bg-secondary-pink-600 text-white px-6 py-3 text-sm md:text-base font-semibold rounded"
                onClick={() => {
                  navigateTo(`/patient/${props?.patient?.id}`);
                }}
              >
                View Patient Profile
              </button>
            ) : (
              <></>
            )}
          </div>
          <div className="bg-white mt-3 px-4 md:px-9 pt-8 pb-2 rounded-md flex flex-row flex-wrap">
            <InfoField label="First Name" value={props.patient.firstName} />
            <InfoField label="Last Name" value={props.patient.lastName} />
            <InfoField
              label="Date of Birth"
              value={moment.utc(props.patient.dob).format('DD/MM/YYYY')}
            />
            <InfoField
              label="Patient Email"
              className="break-words"
              value={<WrapEmail email={props.patient?.email ?? '-'} />}
            />
            <InfoField label="Patient Phone" value={formattedPhoneNumber} />
            <InfoField
              label="Shipping Address"
              className="break-words"
              value={<WrapAddress address={props.patient?.address} />}
            />
          </div>
        </div>
      ) : (
        <></>
      )}
    </>
  );
};
export default PatientPrimaryInfo;
